import { apiStatus } from '@va/constants';
import { RESET_REQUEST_STATUS } from '@va/dashboard/actions/api';
import { applyReducers } from '@va/dashboard/reducers';
import Immutable from 'immutable';
import * as Website from './website';

const apiReducer = (state = Immutable.Map(), action) => {
  switch (action.type) {
    case RESET_REQUEST_STATUS:
      return state.setIn([action.requestName, 'status'], apiStatus.NONE);
    default:
      return applyReducers(state, action, {
        activateDirectAccess: Website.activateDirectAccess,
      });
  }
};
export default apiReducer;
